/**
 * Aviso a pantalla completa fuera de React.
 * No depende de z-index de modales, DialogProvider ni window.alert
 * (Chrome bloquea alert() tras awaits async).
 *
 * opciones.acciones = [{ label, onClick?, primary?, variante? }]
 * Si no hay acciones, un solo botón (opciones.boton).
 */
export function mostrarAvisoVitalCasa(mensaje, opciones = {}) {
  if (typeof document === "undefined") return;
  const id = "vc-aviso-vitalcasa";
  document.getElementById(id)?.remove();

  const titulo = opciones.titulo || "No se pudo completar";
  const esAviso = opciones.variante === "aviso" || opciones.variante === "warning";
  const colorTitulo = esAviso ? "#b45309" : "#b91c1c";
  const colorBorde = esAviso ? "#fde68a" : "#fecaca";
  const colorBtn = esAviso ? "#d97706" : "#dc2626";
  const wrap = document.createElement("div");
  wrap.id = id;
  wrap.setAttribute("role", "alertdialog");
  wrap.setAttribute("aria-modal", "true");
  wrap.style.cssText = [
    "position:fixed",
    "inset:0",
    "z-index:2147483647",
    "background:rgba(15,23,42,0.72)",
    "display:flex",
    "align-items:center",
    "justify-content:center",
    "padding:24px",
    "font-family:system-ui,-apple-system,Segoe UI,sans-serif",
  ].join(";");

  const card = document.createElement("div");
  card.style.cssText = [
    "background:#fff",
    "color:#0f172a",
    "max-width:480px",
    "width:100%",
    "border-radius:16px",
    "padding:28px 32px",
    "box-shadow:0 25px 60px rgba(0,0,0,0.35)",
    `border:1px solid ${colorBorde}`,
  ].join(";");

  const h = document.createElement("div");
  h.style.cssText = `font-size:18px;font-weight:800;color:${colorTitulo};margin:0 0 12px`;
  h.textContent = titulo;

  const p = document.createElement("div");
  p.style.cssText = "font-size:14px;line-height:1.5;color:#334155;white-space:pre-wrap;margin:0 0 20px";
  p.textContent = String(mensaje || "Error desconocido");

  const footer = document.createElement("div");
  footer.style.cssText = "display:flex;flex-wrap:wrap;gap:10px;justify-content:flex-end;align-items:center";

  const cerrar = () => wrap.remove();
  const acciones = Array.isArray(opciones.acciones) && opciones.acciones.length
    ? opciones.acciones
    : [{ label: opciones.boton || "Entendido", primary: true }];

  let firstBtn = null;
  for (const acc of acciones) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = String(acc.label || "OK");
    const esPrimary = acc.primary !== false && (acc.primary === true || acciones.length === 1);
    const esSec = acc.variante === "secundario" || acc.variante === "validar" || (!esPrimary && acciones.length > 1);
    const bg = acc.variante === "validar"
      ? "#0f766e"
      : (esSec && !esPrimary ? "#64748b" : colorBtn);
    btn.style.cssText = [
      "padding:10px 18px",
      "border:none",
      "border-radius:10px",
      `background:${bg}`,
      "color:#fff",
      "font-weight:700",
      "font-size:13px",
      "cursor:pointer",
    ].join(";");
    btn.onclick = async () => {
      try {
        if (typeof acc.onClick === "function") await acc.onClick();
      } finally {
        if (acc.cerrar !== false) cerrar();
      }
    };
    footer.appendChild(btn);
    if (!firstBtn) firstBtn = btn;
  }

  card.appendChild(h);
  card.appendChild(p);
  card.appendChild(footer);
  wrap.appendChild(card);
  wrap.addEventListener("click", (e) => {
    if (opciones.cerrarSoloConBoton) return;
    if (e.target === wrap) cerrar();
  });
  document.body.appendChild(wrap);
  try {
    firstBtn?.focus();
  } catch {
    /* ignore */
  }
}
